import React from 'react';
import { SearchProductInput } from '../components/SearchProductInput';
import { SelectedProductsTable } from '../components/SelectedProductsTable';
import { BottomMenu } from '../components/BottomMenu';


import { Container, Heading, Stack } from '@chakra-ui/react';


export const MainSale = () => {

  return (
    <Container maxWidth="1200px" mt="8">
      <Stack>
        <Heading>
          Buscar producto
        </Heading>
        <SearchProductInput/>
        <Heading>
          Productos agregados
        </Heading>
        <SelectedProductsTable />
        <BottomMenu />
      </Stack>
    </Container>
  );
};
